/* global Word */
import type { TemplateProfile } from '../templates';
import type { ElementDefinition } from './types';
import { runAtCursor } from '../word/context/runAtCursor';

function toHex(color: string): string {
  return color.startsWith('#') ? color : `#${color}`;
}

/** Element definition for first-level section header insertion. */
export const sectionHeader1Element: ElementDefinition = {
  id: 'section-header-1',
  label: 'Header 1',
  icon: 'TextHeader1Regular',
  description: 'Header 1 formatted section title',
  category: 'structural',
  async insertAsync(profile: TemplateProfile): Promise<void> {
    await runAtCursor(async (range, context) => {
      const para = range.insertParagraph('Section Title', Word.InsertLocation.after);
      para.font.name = profile.typography.fontFamily;
      para.font.size = 12;
      para.font.bold = true;
      para.font.color = toHex(profile.colorPalette.exhibitDesc);
      para.spaceBefore = 12;
      para.spaceAfter = 6;
      await context.sync();
    });
  },
};

/** Element definition for second-level section header insertion. */
export const sectionHeader2Element: ElementDefinition = {
  id: 'section-header-2',
  label: 'Header 2',
  icon: 'TextHeader2Regular',
  description: 'Header 2 formatted section title',
  category: 'structural',
  async insertAsync(profile: TemplateProfile): Promise<void> {
    await runAtCursor(async (range, context) => {
      const para = range.insertParagraph('Section Title', Word.InsertLocation.after);
      para.font.name = profile.typography.fontFamily;
      para.font.size = profile.typography.graphHintSize;
      para.font.bold = true;
      para.font.color = toHex(profile.colorPalette.sourceText);
      para.spaceBefore = 12;
      para.spaceAfter = 6;
      await context.sync();
    });
  },
};
